import { render, staticRenderFns } from "./noAcess.vue?vue&type=template&id=43be2273&scoped=true"
import script from "./noAcess.vue?vue&type=script&lang=js"
export * from "./noAcess.vue?vue&type=script&lang=js"
import style0 from "./noAcess.vue?vue&type=style&index=0&id=43be2273&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43be2273",
  null
  
)

export default component.exports